import React from "react";
import { Helmet } from "react-helmet";
import { useLocation } from "react-router-dom";

export default function HelmetMetaData(props) {
  let location = useLocation();
  let currentUrl = process.env.REACT_APP_URL + location.pathname;
  let quote = props.quote !== undefined ? props.quote : "";
  let title =
    props.title !== undefined
      ? props.title
      : "WINDS - World's Largest Happiness Program";
  let image =
    props.image !== undefined
      ? props.image
      : "https://winds-admin.s3.ap-south-1.amazonaws.com/images/og_1.png";
  let description =
    props.description !== undefined
      ? props.description
      : "Rewards, Online Shopping, Recharges & Utility Payments, Brand Vouchers, Nearby Retail Outlets. Collect 5,000 WRP & stand a chance to win up to crores every month.";

  let hashtag = props.hashtag !== undefined ? props.hashtag : "#winds";

  return (
    <Helmet>
      <title>{title}</title>
      <meta charset="utf-8" />
      <meta http-equiv="X-UA-Compatible" content="IE=edge" />
      <meta name="csrf_token" content="" />
      <meta property="type" content="website" />
      <meta property="url" content={currentUrl} />
      <meta
        name="viewport"
        content="width=device-width, initial-scale=1, shrink-to-fit=no"
      />
      <meta name="msapplication-TileColor" content="#ffffff" />
      <meta name="msapplication-TileImage" content="/ms-icon-144x144.png" />
      <meta name="theme-color" content="#ffffff" />
      <meta name="_token" content="" />
      <meta name="robots" content="noodp" />
      <meta property="title" content={title} />
      <meta property="quote" content={quote} />
      <meta name="description" content={description} />
      <meta property="image" content={image} />
      <meta property="og:locale" content="en_IN" />
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:quote" content={quote} />
      <meta property="og:hashtag" content={hashtag} />
      <meta property="og:image" content={image} />
      <meta content="image/*" property="og:image:type" />
      <meta property="og:url" content={currentUrl} />
      <meta property="og:site_name" content="CampersTribe" />
      <meta property="og:description" content={description} />

      {/*  Open Graph / Facebook  */}
      <meta
        property="og:type"
        content="website"
      />
      <meta
        property="og:url"
        content={process.env.REACT_APP_URL}
      />
      <meta
        property="og:title"
        content="WINDS - World's Largest Happiness Program"
      />
      <meta
        property="og:description"
        content="Rewards, Online Shopping, Recharges &amp; Utility Payments, Brand Vouchers, Nearby Retail Outlets. Collect 5,000 WRP & stand a chance to win up to crores every month."
      />
      <meta
        property="og:image"
        content="https://winds-admin.s3.ap-south-1.amazonaws.com/images/og_1.png"
      />

      {/*  Open Graph / twitter  */}
      <meta
        property="twitter:card"
        content="https://winds-admin.s3.ap-south-1.amazonaws.com/images/og_1.png"
      />
      <meta
        property="twitter:url"
        content= {process.env.REACT_APP_URL}
      />
      <meta
        property="twitter:title"
        content="WINDS - World's Largest Happiness Program"
      />
      <meta
        property="twitter:description"
        content="Rewards, Online Shopping, Recharges &amp; Utility Payments, Brand Vouchers, Nearby Retail Outlets. Collect 5,000 WRP & stand a chance to win up to crores every month."
      />
      <meta
        property="twitter:image"
        content="https://winds-admin.s3.ap-south-1.amazonaws.com/images/og_1.png"
      />
    </Helmet>
  );
}
